export { default } from './Page404'


// WEBPACK FOOTER //
// ./src/scenes/Page404/index.js